import styles from './send-certificate-dialog.module.scss';
import { useContext, useState } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, GrayOutlinedButton, LoadingButton, SnackBarContext, Typography } from '@frontend-workspace/react-shared-lib';
import { IRegistrationPeriod } from '../../../../_models/registration-period';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface SendCertificateDialogProps {
  onClose: () => void,
  open: boolean,
  sendCertificate: IRegistrationPeriod
}

export function SendCertificateDialog(props: SendCertificateDialogProps) {
  const { t } = useTranslation();
  const { setSnackbarMessage } = useContext(SnackBarContext);
  const [loading, setLoading] = useState<boolean>(false);

  const handleSendCertificate = () => {
    setLoading(true);
    fetch(`https://surveyserver.azurewebsites.net/course/${props.sendCertificate.courseId}/respondant/${props.sendCertificate.email}/action/sendCertificate`)
      .then(result => {
        if (result.ok) {
          setSnackbarMessage({ content: t('sendCertificate.courseCertificateSent'), type: 'success' });
          setLoading(false);
          props.onClose();
        } else {
          setSnackbarMessage({ content: t('sendCertificate.errorWhenSendingCourseCertificate'), type: 'error' });
        }
      }).catch(error => console.log(error));
  };

  return (
    <Dialog
      open={props.open}
      maxWidth="sm"
      fullWidth>
      <DialogTitle className='mb-4'>
        {t('sendCertificate.areYouSureYouWantToSendCourseCertificates')}
      </DialogTitle>
      <DialogContent>
        <Typography
          component="div"
          variant='subtitle3'
          className='mb-2'>
          {props.sendCertificate.invoiceContactPerson}
        </Typography>
        <Typography
          component="div"
          variant='subtitle3'
          className='mb-3'>
          {props.sendCertificate.email}
        </Typography>
      </DialogContent>
      <DialogActions>
        <LoadingButton
          variant="contained"
          size='large'
          color='secondary'
          onClick={handleSendCertificate}
          disabled={loading}
          loading={loading}
          className='minButtonWidth'>
          {loading ? '' : 'Send'}
        </LoadingButton>
        <GrayOutlinedButton
          variant="outlined"
          size='large'
          onClick={props.onClose}
          className='minButtonWidth'>
          {t('standard.cancel')}
        </GrayOutlinedButton>
      </DialogActions>
    </Dialog>
  );
}

export default SendCertificateDialog;
